import { CreateLicenseRoutine, FetchLicensesRoutine } from '../redux-routines';
import type { ILicenseTemplate, IPayloadAction, TLicensesListState } from '../interfaces';

export const initialState: TLicensesListState = {
  isFetching: false,
  data: [],
  error: null,
};

export const licensesListReducer = (
  state: TLicensesListState = initialState,
  action: IPayloadAction,
): TLicensesListState => {
  switch (action.type) {
    case FetchLicensesRoutine.REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null,
      };
    case FetchLicensesRoutine.SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.payload as ILicenseTemplate[],
        error: null,
      };
    case FetchLicensesRoutine.FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.payload as Error,
      };
    case CreateLicenseRoutine.SUCCESS:
      return {
        ...state,
        data: [...state.data, action.payload as ILicenseTemplate],
      };
    case CreateLicenseRoutine.FAILURE:
      return {
        ...state,
        error: action.payload as Error,
      };
    default:
      return state;
  }
};
